const PluginKeys = {
  IsoPlugin: 'iso-plugin',
  Iso: 'iso',
  IsoPhysicsPlugin: 'iso-physics-plugin',
  IsoPhysics: 'isoPhysics',
  RexUI: 'rexUI',
};

export default PluginKeys;
